import axios from 'axios';
import cookies from 'utils/cookies';
import humps from 'humps';
import { AUTH_TOKEN } from 'constants/AppConstant';

const service = axios.create({
  timeout: 60000,
  baseURL: import.meta.env.VITE_API,
});

// API Request interceptor
service.interceptors.request.use((config) => {
  const jwtToken = cookies.get(AUTH_TOKEN);
  if (jwtToken) {
    config.headers['Authorization'] = `Bearer ${jwtToken}`;
  }

  if (config.data && !(config.data instanceof FormData)) {
    config.data = humps.decamelizeKeys(config.data);
  }

  if (config.params) {
    config.params = humps.decamelizeKeys(config.params);
  }

  return config;
});

service.interceptors.response.use(
  (response) => {
    const contentType = response.headers['content-type'];
    if (response.data && contentType && contentType.includes('application/json')) {
      response.data = humps.camelizeKeys(response.data);
    }
    return response.data;
  },
  (error) => {
    if (error.response && error.response.data) {
      const contentType = error.response.headers['content-type'];
      if (contentType && contentType.includes('application/json')) {
        error.response.data = humps.camelizeKeys(error.response.data);
      }
    }
    if (error.response.status === 401) {
      cookies.remove(AUTH_TOKEN);
    }

    return Promise.reject(error);
  }
);

export default service;
